import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import StructuredData from "../components/StructuredData";
import SuburbsIndexContent from "../components/SuburbsIndexContent";
const Suburbs = () => {
  return (
    <>
      <SEO
        title='Car Rental Suburbs Melbourne | Local Car Hire Areas | EZ Car Rentals'
        description='Browse all suburbs served by EZ Car Rentals across Melbourne. Affordable car, SUV, van and ute hire with pickup from Huntingdale near Oakleigh, Clayton, Chadstone and more.'
        keywords='car rental suburbs Melbourne, car hire near me, EZ Car Rentals suburbs, local car rental Melbourne, Huntingdale car hire'
        url='https://ezcarrentals.com.au/suburbs'
      />
      <StructuredData type='organization' />
      <Navbar />
      <SuburbsIndexContent />
      <Footer />
    </>
  );
};

export default Suburbs;
